import { createContext, type Dispatch, type SetStateAction } from "react";
import type { AppThemeMode } from "../theme";

export interface AppState {
  themeMode: AppThemeMode;
}

export interface AppContextValue {
  state: AppState;
  setState: Dispatch<SetStateAction<AppState>>;
  setThemeMode: (mode: AppThemeMode) => void;
  toggleTheme: () => void;
}

export const initialAppState: AppState = {
  themeMode: "dark",
};

export const AppContext = createContext<AppContextValue | undefined>(undefined);
